import api from "api/landlord/address";
import { getSourceLabel } from "utils/getSourceLabel";

// Separate from asyncUnitProperties#loadUnitOptions: that one disables units with no active magic link.
export const loadUnitOptions = async (
  search: string,
  _,
  {
    page,
    propertyId
  }: {
    page: number;
    propertyId: number;
  }
) => {
  if (!propertyId) return { options: [], hasMore: false };

  const data = await api.getUnitsOfProperty({
    propertyId,
    searchTerm: search || "",
    page
  });

  return {
    options: data?.items?.map((item) => ({
      value: item.id,
      label: item.title,
      sourceLabel: getSourceLabel(item)
    })),
    hasMore: data.has_more,
    additional: {
      page: page + 1,
      propertyId
    }
  };
};
